export default "__VITE_ASSET__DdQcqffY__"